module.exports = __webpack_public_path__ + "static/media/014.4d0d503d.jpg";